export const TOGGLE_USER_SENTIMENT = 'TOGGLE_USER_SENTIMENT';
export const CLOSE_USER_SENTIMENT = 'CLOSE_USER_SENTIMENT';

export const toggleUserSentiment = () => ({
  type: TOGGLE_USER_SENTIMENT,
});

export const closeUserSentiment = () => ({
  type: CLOSE_USER_SENTIMENT,
});
